import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { useUIStore } from '../../../store';

const WebhookPage = ({ sess = { uid: '', role: 'user' } }) => {
  const [formData, setFormData] = useState({
    url: '',
    secret: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const showSnackbar = useUIStore((state) => state.showSnackbar);

  useEffect(() => {
    const fetchWebhook = async () => {
      try {
        const response = await fetch('/chatbot/api/v1.0/webhook/get', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ uid: sess.uid }),
        });
        const result = await response.json();
        if (result?.data) {
          setFormData({
            url: result.data.url || '',
            secret: result.data.secret || '',
          });
        }
      } catch (err) {
        console.error('Error fetching webhook:', err);
        setError('Failed to load webhook settings');
      } finally {
        setLoading(false);
      }
    };
    fetchWebhook();
  }, [sess.uid]);

  useEffect(() => {
    if (!message) return;
    showSnackbar({ message, severity: 'success' });
    setMessage('');
  }, [message, showSnackbar]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const response = await fetch('/chatbot/api/v1.0/webhook/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, uid: sess.uid }),
      });
      const result = await response.json();
      if (response.ok) {
        setMessage(result.message || 'Webhook updated successfully');
      } else {
        setError(result.message || 'Failed to update webhook');
      }
    } catch (err) {
      setError('Error updating webhook');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" mb={2}>
        <Button variant="outlined" startIcon={<ArrowLeft size={16} />} href="/settings">
          Back
        </Button>
        <Typography variant="h5">Webhook Settings</Typography>
      </Stack>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Webhook URL"
                name="url"
                value={formData.url}
                onChange={handleChange}
                fullWidth
                required
              />
              <TextField
                label="Signing Secret"
                name="secret"
                value={formData.secret}
                onChange={handleChange}
                fullWidth
              />
              <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button variant="outlined" href="/settings">
                  Cancel
                </Button>
                <Button type="submit" variant="contained" disabled={saving}>
                  {saving ? 'Saving...' : 'Save'}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default WebhookPage;
